import { render } from "./OrderList.vue?vue&type=template&id=1fde5339&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=1fde5339&scoped=true&lang=css"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fde5339"]])

export default __exports__